import { useCallback, useEffect, useMemo, useState } from "react";

import { uniqBy } from "lodash";

import { DocumentDataField } from "../../constants";
import { ALL_INVESTORS_VALUE } from "../../constants/tagger";
import { useGetDealRoundInvestorsQuery } from "../../queries/query-selectors/tagger-query-selectors";
import { useTaggerActions, useTaggerDocumentSelector } from "../../store";
import { IProcessedTag, TaggerDocument } from "../../store/types";

const useInvestors = (docId: TaggerDocument["id"], tag?: IProcessedTag) => {
  const doc = useTaggerDocumentSelector(docId);
  const { changeDocumentData } = useTaggerActions();
  const { data, isLoading } = useGetDealRoundInvestorsQuery(doc.dealId);

  const [value, setValue] = useState<number | null>(null);

  const handleChange = useCallback((value: number | null) => {
    setValue(value);
    changeDocumentData(docId, DocumentDataField.SelectedInvestor, value);
  }, []);

  useEffect(() => {
    setValue(tag?.investor?.id ?? null);
  }, [tag]);

  const options = useMemo(() => {
    const investorIds = uniqBy(data?.map((round) => round.investors).flat(), "id");
    const options = investorIds.map((item) => ({ value: item.id, label: item.name }));

    if (options.length) {
      options.unshift({
        value: ALL_INVESTORS_VALUE,
        label: "All investors - Split by commitment"
      });
    }

    return options;
  }, [data]);

  return {
    options: options,
    value: value,
    loading: isLoading,
    onChange: handleChange
  };
};

export default useInvestors;
